// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconSharedBy = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13">
            <path
                fill="currentColor"
                d="M5.25,6 C6.90703154,6 8.25,4.65679693 8.25,3 C8.25,1.34320307 6.90703154,0 5.25,0 C3.59296882,0 2.25,1.34320307 2.25,3 C2.25,4.65679693 3.59296882,6 5.25,6 Z M6.43828154,7.125 L4.06171882,7.125 C1.81898439,7.125 0,8.94375014 0,11.1867185 C0,11.6353126 0.3637501,11.9992972 0.812343836,11.9992972 L9.68812537,11.9992972 C10.1367188,12 10.5,11.6367188 10.5,11.1867185 C10.5,8.94375014 8.68124986,7.125 6.43828154,7.125 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconSharedBy);
